<template>
  <div class="instance-entity-table-cell">
    <div class="status" v-if="hasUserEntity">
      <span class="body2 display-block mb-10">User</span>
      <span class="body2">
        {{ entities.user }}
      </span>
    </div>
    <div class="status" v-if="hasHostEntity">
      <span class="body2">Host</span>
      <router-link
        class="value display-block mb-10"
        :to="{ name: 'host-insights', params: { agentId: entities.agentId } }"
      >
        <a class="body3">{{ entities.host }}</a>
      </router-link>
    </div>
    <div class="status" v-if="hasIpEntity">
      <span class="body2 display-block mb-10">IP</span>
      <span class="body2">
        {{ entities.ip }}
        <span v-if="!$_.isEmpty(entities.city)">{{ entities.city }}, {{ entities.country }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstanceEntityTableCell',
  props: {
    entities: {
      type: [Object]
    }
  },
  data () {
    return {}
  },
  mounted () {},
  computed: {
    hasHostEntity () {
      return _.keys(this.entities).includes('agentId') || _.keys(this.entities).includes('host')
    },
    hasIpEntity () {
      return _.keys(this.entities).includes('ip')
    },
    hasUserEntity () {
      return _.keys(this.entities).includes('user')
    },
    hasCityEntity () {
      return _.keys(this.entities).includes('city')
    },
    hasCountryEntity () {
      return _.keys(this.entities).includes('country')
    }
  }
}
</script>

<style scoped>
.instance-entity-table-cell {
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/table/cell/InstanceEntityTableCell.vue